import React from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {theme} from '../../../../styles';

export default function LayersExplained({
    setStepCount,
    onSidebarChange,
}: {
    setStepCount: SetState<number>;
    onSidebarChange: SetState<SidebarState>;
}) {
    return (
        <div>
            <Typography variant='h5' style={{marginTop: theme.spacing(2)}}>
                Add and view different maps.
            </Typography>
            <Typography variant='body1' style={{margin: theme.spacing(1)}}>
                Click the layers icon to change the visible map. Depending on
                the area or activity you are doing, you may find a different map
                with information you need.
            </Typography>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: theme.spacing(2),
                }}
            >
                <Button
                    style={{fontSize: 14}}
                    onClick={() =>
                        setStepCount((prevState: number) => prevState - 1)
                    }
                >
                    Back
                </Button>
                <Button
                    color='primary'
                    variant='contained'
                    style={{fontSize: 14}}
                    onClick={() => {
                        onSidebarChange({type: 'hidden'});
                        setStepCount((prevState: number) => prevState + 1);
                    }}
                >
                    Next
                </Button>
            </div>
        </div>
    );
}
